(() => {
  if (customElements.get('dhz-dealer-directory')) return;
  customElements.define('dhz-dealer-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const search = this.querySelector('[data-dealer-search]');
      const cards = [...this.querySelectorAll('[data-dealer-card]')];
      const buttons = [...this.querySelectorAll('[data-dealer-state]')];
      const resets = [...this.querySelectorAll('[data-dealer-reset]')];
      let state = '';
      const normalize = value => value.toLowerCase().trim().replace(/\s+/g, ' ');
      const update = () => {
        const terms = normalize(search.value).split(' ').filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const matches = (!state || card.dataset.state === state) && terms.every(term => normalize(card.dataset.search).includes(term));
          card.hidden = !matches;
          if (matches) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dealerState === state)));
        this.querySelector('[data-dealer-count]').textContent = `${count} ${count === 1 ? 'dealer' : 'dealers'} ${state ? `in ${state}` : 'across Australia'}${terms.length ? ' matching your search' : ''}`;
        this.querySelector('[data-dealer-empty]').hidden = count > 0;
        resets[0].hidden = !state && !terms.length;
      };
      search.addEventListener('input', update);
      buttons.forEach(button => button.addEventListener('click', () => { state = button.dataset.dealerState; update(); }));
      resets.forEach(button => button.addEventListener('click', () => { state = ''; search.value = ''; update(); search.focus(); }));
      this.addEventListener('shopify:block:select', event => {
        if (!event.target.matches('[data-dealer-card]')) return;
        state = ''; search.value = ''; update();
      });
      this.querySelector('.dealers-controls').hidden = false;
      update();
    }
  });
})();
